import { LoadingSpinner } from "thrive-components"
import LoadingCircle from "../global/LoadingCircle/LoadingCircle"

export const SavingFeedAsDraft = () => (
    <span className="saving-draft-list"><span>Saving Feed as draft</span> <span className='loading-circle'><LoadingCircle /></span></span>
)

export const AddSourceListExplainer = () => (
    <div className='add-source-list-explainer'>
        Add your first source list.
    </div>
)

export const EditSourceListButtonContent = ({isLoading, isEdit}:{isLoading: boolean, isEdit: boolean}) => {
    return (
        <span className="new-button">
            {isLoading 
                ?    <span className="loading-spinner"><LoadingSpinner size={10} /></span>
                :   <>
                        <span>{isEdit ? "Edit Source Lists" : "Add Source Lists"}</span>
                        <span className='plus'>+</span>
                    </>
            }
        </span>
    )
}